"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FiltersType = exports.AnalyticsTabEnum = exports.AnalyticsTypeEnum = exports.FeedbackObject = exports.Language = exports.ThumbType = exports.SlideTypes = exports.ModuleStatuses = void 0;
const t = __importStar(require("io-ts"));
exports.ModuleStatuses = t.keyof({
    NotStarted: "NotStarted",
    InProgress: "InProgress",
    Completed: "Completed",
    Validated: "Validated",
    Failed: "Failed",
    Abandoned: "Abandoned",
});
exports.SlideTypes = t.keyof({
    Sheet: "Sheet",
    SingleChoice: "SingleChoice",
    MultipleChoice: "MultipleChoice",
    BinaryQuestion: "BinaryQuestion",
    Case: "Case",
});
exports.ThumbType = t.keyof({
    up: "up",
    down: "down",
});
exports.Language = t.keyof({
    "fr-fr": "fr-fr",
    "en-us": "en-us",
    "en-gb": "en-gb",
    "es-es": "es-es",
    "de-de": "de-de",
    "it-it": "it-it",
    "pt-pt": "pt-pt",
    "nl-nl": "nl-nl",
    "pl-pl": "pl-pl",
});
exports.FeedbackObject = t.keyof({
    General: "General",
    Slide: "Slide",
    PublishedModule: "PublishedModule",
});
var AnalyticsTypeEnum;
(function (AnalyticsTypeEnum) {
    AnalyticsTypeEnum["Module"] = "Module";
    AnalyticsTypeEnum["Program"] = "Program";
})(AnalyticsTypeEnum = exports.AnalyticsTypeEnum || (exports.AnalyticsTypeEnum = {}));
var AnalyticsTabEnum;
(function (AnalyticsTabEnum) {
    AnalyticsTabEnum["Users"] = "Users";
    AnalyticsTabEnum["Steps"] = "Steps";
})(AnalyticsTabEnum = exports.AnalyticsTabEnum || (exports.AnalyticsTabEnum = {}));
exports.FiltersType = t.type({
    assignationRange: t.union([t.array(t.string), t.null]),
    users: t.union([t.array(t.number), t.null]),
    groups: t.union([t.array(t.number), t.null]),
    roles: t.union([t.array(t.number), t.null]),
    labels: t.union([t.array(t.number), t.null]),
    progressStatuses: t.union([t.array(t.string), t.null]),
    progressRange: t.union([t.array(t.number), t.null]),
    scoreStatuses: t.union([t.array(t.string), t.null]),
    scoreRange: t.union([t.array(t.number), t.null]),
});
